import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-e', 'LetterE', [["path",{"d":"M17 4h-10v16h10"}],["path",{"d":"M7 12l8 0"}]]);